export default __webpack_public_path__ + "static/media/ic_question_answer.4c945505.svg";